<template>
  <a-select
    :value="value"
    allow-clear
    show-search
    :multiple="false"
    :placeholder="placeholder"
    option-filter-prop="title"
    @change="onChange"
    @clear="onClear"
    @search="handleSearch"
  >
    <a-select-option v-for="item in result || []" :value="item.id" :title="item.name">
      <div v-if="keyword" v-html="searchFun(keyword, item.name)"></div>
      <div v-else>{{ item.name }}</div>
    </a-select-option>
    <template #dropdownRender="{ menuNode: menu }">
      <v-nodes :vnodes="menu" />
      <a-divider style="margin: 4px 0" />
      <div
        v-perm="'material-brand-create'"
        style="padding: 4px 8px; cursor: pointer; color: rgba(0, 0, 0, 0.85)"
        @mousedown="(e) => e.preventDefault()"
        @click="addItem"
      >
        <form-btn
          :material-category-id="categoryId"
          :default-brand="addText"
          @refresh="finishCreateBrand"
        >
          <template #addBrand="{ showCreateModal }">
            <div @click="showCreateModal">
              <plus-outlined />
              <template v-if="addText">
                新建品牌 <span style="color: #317efd">"{{ addText }}"</span>
              </template>
              <template v-else> 新建品牌 </template>
            </div>
          </template>
        </form-btn>
      </div>
    </template>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, watch, onMounted, ref, PropType, nextTick, toRaw } from "vue";
import { BrandService } from "@/views/material/brand/brand.service";
import { Brand } from "@/views/material/library/library.interface";
import { PlusOutlined } from "@ant-design/icons-vue";
import FormBtn from "@/views/material/brand/components/form-btn/index.vue";
import { BrandReq } from "@/views/material/brand/brand.interface";

interface FinshFnPayload extends BrandReq {
  id?: string;
}

/**
 * 品牌选择器
 * <brand-select v-model:value="formRef.brandId"></brand-select>
 */
export default defineComponent({
  name: "BrandSelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String,
      default: undefined,
    },
    categoryId: {
      type: String,
      default: undefined,
    },
    brandList: {
      type: Array as PropType<Brand[]>,
      default: () => [],
    },
  },
  components: {
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
    PlusOutlined,
    FormBtn,
  },
  emits: ["update:value", "update:brandList", "finishCreateBrand"],
  setup(props, { attrs, slots, emit }) {
    const keyword = ref("");

    const result = ref<Brand[]>([]);
    const { data, run, loading } = BrandService.useSimpleListApi();
    const onChange = (id) => {
      keyword.value = "";
      emit("update:value", id);
    };
    const onClear = () => {
      emit("update:value", "");
    };
    onMounted(async () => {
      result.value = props.brandList;
    });

    async function updateBrandList(categoryId) {
      await run({ materialCategoryId: categoryId });
      result.value = (data.value as any)?.records ?? [];
      emit("update:brandList", result.value);
    }

    watch(
      () => props.categoryId,
      async (categoryId, o) => {
        if (categoryId) {
          await updateBrandList(categoryId);
        }
      }
    );

    const addText = ref("");

    function addItem() {}

    function handleSearch(value) {
      keyword.value = value;
      if (result.value?.some((ele) => ele.name.toLowerCase().indexOf(value.toLowerCase()) >= 0)) {
        addText.value = "";
        return;
      }

      addText.value = value;
    }

    async function finishCreateBrand(newBrand: FinshFnPayload) {
      emit("finishCreateBrand", newBrand);
      const name = newBrand.name;
      const materialCategoryId = newBrand.materialCategoryId;
      const categoryId = props.categoryId || "";

      if (materialCategoryId?.includes(props.categoryId as string) && newBrand.id) {
        await updateBrandList(categoryId);
        emit("update:value", newBrand.id);
      }
    }

    function searchFun(kw, str) {
      if (kw === "") {
        return str;
      }
      if (str === null || str === undefined) {
        return "";
      }
      // 添加正则
      const reg = new RegExp(kw, "g"); // ig 是所有的意思 而非在发现第一个匹配项时立即停止
      // 使用replace方法替换元素产生高亮
      return str.replace(reg, function (match) {
        return '<span style="color:#F59A23">' + match + "</span>";
      });
    }

    return {
      result,
      loading,
      onChange,
      onClear,
      addItem,
      handleSearch,
      addText,
      keyword,
      finishCreateBrand,
      searchFun,
    };
  },
});
</script>
